<template>
  <div>
    <div
      id="modifier-wrapper"
      class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-lg-6">
            <label>{{ $t('message.modifier_name') }} *</label>
            <input
              :class="[class_.name]"
              v-model="data.name"
              :disabled="disabled"
              type="text"
              class="form-control modifier-name"
              @keyup="keyupName()">
          </div>
        </div>
      </div>
      <div class="col-md-12 container-label">
        <label>{{ $t('message.options') }}</label>
      </div>
      <div class="col-md-12 container-items">
        <draggable
          v-model="data.options"
          v-bind="dragOptions"
          tag="div"
          handle=".handle-dragable"
          @start="handleStartDrag"
          @end="handleEndDrag"
        >
          <div
            v-for="(item, index) in data.options"
            :key="index"
            :class="[item.is_invalid]"
            class="item row no-margin">
            <div class="col no-padding">
              <input
                :placeholder="$t('placeholder.option_name')"
                v-model="item.option"
                :disabled="disabled"
                type="text"
                class="form-control"
                @keyup="keyupOption(index)"
                @click="inputClick(index)">
              <div class="wall"/>
            </div>
            <div class="col no-padding">
              <input
                :placeholder="$t('placeholder.price')"
                v-model="item.price"
                :disabled="disabled"
                type="text"
                class="form-control text-select-all"
                @click="inputClick(index)"
                @keypress="numberOnly"
                @keyup="item.price = setToValidNumber(item.price)"
                @blur="item.price = setToCustomDigitsNumber(item.price)">
              <div
                v-if="data.options.length > 1 && index < data.options.length-1 && !disabled"
                class="action-buttons">
                <button
                  class="btn-delete"
                  @click="del(index)">
                  <i class="far fa-trash-alt"/>
                </button>
                <button class="btn-drag handle-dragable">
                  <i class="fa fa-align-justify"/>
                </button>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="col-md-12 mt-3">
        <section-header :title="$t('message.conditional')"/>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <label>{{ $t('message.requiredselect') }}</label>
            <BaseCheckbox
              v-model="data.is_required"
              :label="data.is_required ? $t('message.yes') : $t('message.no')"
              :disabled="isDisabledIsRequired"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group form-row mb-0">
          <div class="col-6 col-md-6 col-lg-3 col-xl-3">
            <label>{{ $t('message.selectlowest') }}</label>
            <select
              v-model="data.min_required_count"
              class="form-control custom-select">
              <option :value="0">{{ $t('message.notspecifiedmodifiercount') }}</option>
              <option
                v-for="(value, index) in minMaxCount"
                :key="index"
                :value="value">{{ $t('message.selectmodifiercount', { number: value }) }}</option>
            </select>
          </div>
          <div class="col-6 col-md-6 col-lg-3 col-xl-3">
            <label>{{ $t('message.selecthighest') }}</label>
            <select
              v-model="data.max_required_count"
              class="form-control custom-select">
              <option :value="0">{{ $t('message.notspecifiedmodifiercount') }}</option>
              <option
                v-for="(value, index) in minMaxCount"
                :key="index"
                :value="value">{{ $t('message.selectmodifiercount', { number: value }) }}</option>
            </select>
          </div>
        </div>
      </div>
      <div
        v-if="getModifierHelperText($t, data).length"
        class="col-md-12 mt-3">
        <div
          class="d-flex"
          style="gap: 10px;">
          <div>
            {{ $t('message.modifiersampletext') }}:
          </div>
          <div>
            {{ data.name }}
          </div>
          <div>
            <div class="text-gray">
              <span>
                -
                {{ getModifierHelperText($t, data) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  props: {
    value: {
      type: Object,
    },
    data: {
      type: Object,
    },
    validation: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      drag: false,
      class_: {
        name: false,
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
    isDisabledIsRequired() {
      if (this.data.min_required_count > 0) {
        return true
      }
      return false
    },
    minMaxCount() {
      const optionsCount = this.data.options.filter((item) => item.option).length
      if (optionsCount < 3) {
        return Math.max(3, this.data.min_required_count, this.data.max_required_count)
      }
      return Math.max(optionsCount, this.data.min_required_count, this.data.max_required_count)
    },
  },
  watch: {
    validation () {
      this.validateform()
    },
    'data.min_required_count': {
      handler: function (value) {
        this.onChangeMinRequiredCount()
      },
      deep: true,
    },
    'data.max_required_count': {
      handler: function (value) {
        this.onChangeMaxRequiredCount()
      },
      deep: true,
    },
  },
  mounted: function () {
    if (!this.disabled) {
      this.add()
    }
  },
  methods: {
    inputClick (index) {
      let isLast = index == this.data.options.length - 1
      if (isLast) {
        this.add()
      }
    },
    add () {
      this.data.options.push({
        option: null,
        price: null,
        is_invalid: '',
      })
    },
    del (index) {
      this.data.options.splice(index, 1)
    },
    keyupName () {
      if (!this.data.name) {
        this.class_.name = 'is-invalid'
      } else {
        this.class_.name = false
      }
    },
    keyupOption (index) {
      if (this.data.options[index].option) {
        this.data.options[index].is_invalid = false
      } else {
        this.data.options[index].is_invalid = 'is-invalid'
      }
    },
    isValid () {
      /*
       *  validation
       */
      const data = this.getData(this.data)
      var isInValidName = false
      var isInValidOptions = false
      var foundAtIdxs = []

      if (this.data.name == null) {
        isInValidName = true
      } else if (typeof this.data.name === 'string') {
        if (this.data.name.trim().length == 0) {
          isInValidName = true
        }
      }

      if (isInValidName) {
        this.class_.name = 'is-invalid'
      } else {
        this.class_.name = false
      }

      for (let i in data.options) {
        let opt = data.options[i]
        if (!opt.option) {
          isInValidOptions = true
          foundAtIdxs.push(parseInt(i))
        }
      }

      if (data.options.length == 0) foundAtIdxs.push(0)

      for (let i in foundAtIdxs) {
        let index = foundAtIdxs[i]
        this.data.options[index].is_invalid = 'is-invalid'
      }

      if (isInValidName || isInValidOptions || data.options.length == 0) {
        return false
      }

      return true
    },
    getData (modifier) {
      var data = {
        modifier_name: modifier.name,
        options: this.getObject(modifier.options),
        is_required: modifier.is_required,
        min_required_count: modifier.min_required_count,
        max_required_count: modifier.max_required_count,
      }

      var newOptions = []

      // remove key, data we don't need
      for (let i in data.options) {
        if (data.options[i].option || data.options[i].price) {
          delete data.options[i].is_invalid
          newOptions.push(data.options[i])
        }
      }

      data.options = newOptions

      // parse float
      for (let i in data.options) {
        data.options[i].price = parseFloat(data.options[i].price) || 0
      }

      return data
    },
    validateform () {
      var data = null
      var isValid = false
      if (this.isValid()) {
        data = this.getData(this.data)
        isValid = true
      }
      this.$emit('data', isValid, data)
    },
    setDisabledIsRequired() {
      if (this.data.min_required_count > 0) {
        return this.data.is_required = true
      }
    },
    onChangeMinRequiredCount() {
      this.setDisabledIsRequired()

      if (this.data.min_required_count > this.data.max_required_count && this.data.max_required_count != 0) {
        this.data.max_required_count = this.data.min_required_count
      }
    },
    onChangeMaxRequiredCount() {
      this.setDisabledIsRequired()
      if (this.data.max_required_count < this.data.min_required_count && this.data.min_required_count != 0) {
        this.data.min_required_count = this.data.max_required_count
      }
    },
    handleStartDrag() {
      this.drag = true
    },
    handleEndDrag() {
      this.drag = false
    },
  },
}
</script>

<style scoped>
.item {
  background: #FFF;
  height: 40px;
  border: 1px solid #ced4da;
  border-bottom: none;
  position: relative;
}
.item.is-invalid {
  border: solid 1px #dc3545;
  border-bottom: solid 1px #dc3545 !important;
}
.item input[type="text"] {
  border: none;
  height: 100%;
  border-radius: 0;
}
.item:last-of-type {
  border-bottom: 1px solid #ced4da;
}
.item .wall {
  position: absolute;
  top: 12px;
  right: 0;
  width: 1px;
  height: 16px;
  background: #ced4da;
}
.action-buttons {
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  height: 100%;
}
.item .btn-delete, .item .btn-drag {
  color: #BBBBBB;
  background: none;
  border: none;
  padding: 7px 10px 5px 10px;
  cursor: pointer;
  height: 100%;
}
.item .btn-drag {
  cursor: move;
}
button:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/Modifier.vue